import { GuestRating } from '../GuestRating'
import { StarRating } from '../StarRating'
import { StyledRatings } from './Ratings.styles'

export type RatingsTranslations = {
  grade?: string
  guestRating?: string
  outOf?: string
}

export type RatingsProps = {
  grade?: number | null
  guestRating?: number | null
  translations?: RatingsTranslations
  idPrefix?: string
}

export const Ratings = ({
  grade,
  guestRating,
  translations = {},
  idPrefix,
}: RatingsProps) => {
  const gradeToShow = typeof grade === 'number' && grade > 0 ? grade : null
  const guestRatingToShow =
    typeof guestRating === 'number' && guestRating > 0 ? guestRating : null

  if (gradeToShow === null && guestRatingToShow === null) return null

  const outOfLabel = translations.outOf ? `${translations.outOf} 5` : 'out of 5'

  return (
    <StyledRatings>
      {gradeToShow !== null && (
        <StarRating
          grade={gradeToShow}
          label={translations.grade || 'Grade'}
          outOfLabel={outOfLabel}
          idPrefix={idPrefix ? `${idPrefix}-grade-star` : undefined}
        />
      )}
      {guestRatingToShow !== null && (
        <GuestRating
          rating={guestRatingToShow}
          label={translations.guestRating || 'Guest Rating'}
          outOfLabel={outOfLabel}
        />
      )}
    </StyledRatings>
  )
}
